var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current)?_c('section',{staticClass:"qcm"},[_c('Question',{attrs:{"current":_vm.current},on:{"next":_vm.handleNext,"result":_vm.addResult}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }